import { FsApiService } from '@/app/services/auth/fs-api.service';
import { inject, Injectable, signal } from '@angular/core';
import { catchError, of } from 'rxjs';
import { ICompetitionsStandingsApi } from '../models';
import { TranslationService } from '@/app/services/translation.service';

@Injectable({
  providedIn: 'root',
})
export class CompetitionStandingsService {
  private fsApi = inject(FsApiService);
  private routingService = inject(TranslationService);

  isLoadingCompetitionsStandings = signal<boolean>(false);
  isErrorCompetitionsStandings = signal<boolean>(false);
  competitionsStandings = signal<ICompetitionsStandingsApi | null>(null);

  constructor() {}

  getCompetitionStandings(competitionId: String) {
    this.isLoadingCompetitionsStandings.set(true);
    this.isErrorCompetitionsStandings.set(false);

    this.fsApi
      .get<ICompetitionsStandingsApi | null>(
        `/competitions/${competitionId}/standings`
      )
      .pipe(
        catchError((_) => {
          this.isLoadingCompetitionsStandings.set(false);
          this.isErrorCompetitionsStandings.set(true);

          return of(null);
        })
      )
      .subscribe((data) => {
        if (!data) {
          this.isLoadingCompetitionsStandings.set(false);
          this.competitionsStandings.set(null);
          return;
        }

        const newData = data as ICompetitionsStandingsApi;

        const stageStandings = newData.StageStandings ?? [];

        newData.StageStandings = stageStandings.map((standing) => {
          const groupStandings = standing.GroupStandings ?? [];

          return {
            ...standing,
            GroupStandings: groupStandings.map((groupStanding) => {
              const teams = groupStanding.Teams ?? [];

              return {
                ...groupStanding,
                Teams: teams.map((team) => ({
                  ...team,
                  Link: this.routingService.getTraslateUrlTeamDetails(
                    team.NameTranslation ?? {},
                    team.Name,
                    team.Id
                  ),
                })),
              };
            }),
          };
        });

        this.isLoadingCompetitionsStandings.set(false);
        this.competitionsStandings.set(newData);
      });
  }
}
